import { useState, useEffect } from "react";

export default function useAltKeyDown() {
  const [isAltDown, setIsAltDown] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey){
        e.preventDefault();
        setIsAltDown(true);
      }
    };

    const handleKeyUp = (e) => {
      if (!e.altKey){
        e.preventDefault();
        setIsAltDown(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return isAltDown;
}

